import index from './Rbv3s';

export default index;
